import React from 'react';
import Tag from '../Tag';

export interface TagBetaProps {
  id?: string;
}

const TagBeta: React.FC<TagBetaProps> = ({ id }) => {
  return <Tag id={id} text="BETA" type="beta" />;
};

export default TagBeta;
